/**
 * 006 · T036 · Card de instalación en Android (research R-22): recuerda cuándo el trabajador tocó
 * "Ahora no" en `localStorage` para no volver a mostrarla hasta que pasen
 * `INSTALL_CARD_SNOOZE_DAYS`. Nada de esto es dato de asistencia: solo una marca de tiempo propia
 * del dispositivo, permitida por §0.7/§10.6 de wiring.md.
 */

/** Clave en `localStorage`: fecha ISO de la última vez que se pospuso la card. */
export const INSTALL_CARD_DISMISSED_KEY = 'fermin:install-card-dismissed-at';

/** Días que se pospone la card tras tocar "Ahora no" (design-system §8.1). */
export const INSTALL_CARD_SNOOZE_DAYS = 7;

const SNOOZE_MS = INSTALL_CARD_SNOOZE_DAYS * 24 * 60 * 60 * 1000;

/** `localStorage` puede lanzar en modo privado o estar ausente fuera del navegador. */
function storage(): Storage | undefined {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
}

/** Registra que el trabajador tocó "Ahora no" en este momento. */
export function dismissInstallCard(now: Date = new Date()): void {
  storage()?.setItem(INSTALL_CARD_DISMISSED_KEY, now.toISOString());
}

/**
 * `true` si la card se pospuso hace menos de `INSTALL_CARD_SNOOZE_DAYS`, sea porque nunca se
 * pospuso (`false`) o porque ya pasó el plazo (`false`, reaparece).
 */
export function isInstallCardSnoozed(now: Date = new Date()): boolean {
  const dismissedAt = storage()?.getItem(INSTALL_CARD_DISMISSED_KEY);
  if (dismissedAt === null || dismissedAt === undefined) {
    return false;
  }
  const dismissedAtMs = new Date(dismissedAt).getTime();
  if (Number.isNaN(dismissedAtMs)) {
    return false;
  }
  return now.getTime() - dismissedAtMs < SNOOZE_MS;
}
